<template>
    <div style="padding: 0 4px">
        <v-navigation-drawer
            v-model="primaryDrawer.model"
            :clipped="primaryDrawer.clipped"
            :floating="primaryDrawer.floating"
            :mini-variant="primaryDrawer.mini"
            :permanent="primaryDrawer.type === 'permanent'"
            :temporary="primaryDrawer.type === 'temporary'"
            app
            overflow>
            <div class="pa-2 pl-4 pt-4">
                <img :src="appLogoUrl" width="140" alt="CRM">
            </div>
            <v-divider></v-divider>
            <v-list-item three-line>
                <v-list-item-avatar v-if="false">
                    <img src="https://randomuser.me/api/portraits/women/81.jpg" alt="Аватар">
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title data-test="nav-user-name">{{ user.fullName }}</v-list-item-title>
                    <v-list-item-subtitle>{{ user.roleDesc }}</v-list-item-subtitle>
                    <div class="pt-2">
                        <v-btn data-test="nav-logout" color="error" outlined x-small @click="logout">Выйти</v-btn>
                    </div>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list dense>
                <template v-for="menu in userMenu">
                    <v-list-group v-if="menu.children" :key="menu.title" :prepend-icon="menu.icon" no-action>
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{ menu.title }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item v-for="child in menu.children" :key="child.title" link :to="child.link"
                                     :data-test="'nav-link-' + child.link">
                            <v-list-item-icon>
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ child.title }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item v-else :key="menu.title" link :to="menu.link"
                                 :data-test="'nav-link-' + menu.link">
                        <v-list-item-icon>
                            <v-icon>{{ menu.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ menu.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
            <v-divider></v-divider>
            <!-- ADMIN of a billed installation: balance / paid days (specs/saas-subscription.md) -->
            <template v-if="subscriptionInfo && subscriptionInfo.billed">
                <div class="px-4 py-3" data-test="subscription-widget">
                    <div class="text-subtitle-2">
                        {{ subscriptionInfo.planName ? `Доступ «${subscriptionInfo.planName}»` : 'Оплата системы' }}
                    </div>
                    <div v-if="subscriptionInfo.balance != null" class="text-body-2 mt-1">
                        Баланс: <b>{{ formatMoney(subscriptionInfo.balance) }} ₽</b>
                    </div>
                    <div v-if="subscriptionInfo.daysLeft != null" class="text-body-2 font-weight-medium"
                         :class="subscriptionDaysClass" :title="`Оплачено до ${formatDate(subscriptionInfo.paidUntil)}`">
                        {{ subscriptionInfo.daysLeft === 0 ? 'Оплата закончилась'
                            : `Осталось: ${subscriptionInfo.daysLeft} ${pluralDays(subscriptionInfo.daysLeft)}` }}
                    </div>
                </div>
                <v-divider></v-divider>
            </template>
            <Billing
                v-if="false && $helper.permission.canSeeTheBilling(user)">
            </Billing>
            <LawyerPlan
                v-if="false && $helper.permission.canSeeLawyerPlan(user)">
            </LawyerPlan>
            <Settings></Settings>
        </v-navigation-drawer>
        <v-app-bar :clipped-left="primaryDrawer.clipped" app>
            <v-app-bar-nav-icon data-test="nav-toggle" @click.stop="primaryDrawer.model = !primaryDrawer.model"/>
            <Birthday></Birthday>
            <v-spacer></v-spacer>
            <v-btn
                v-if="$helper.permission.canSeeSettings(user)"
                to="/settings"
                text>
                <v-icon>mdi-cog-outline</v-icon>
            </v-btn>
            <v-btn
                text
                v-if="$helper.permission.canSeeNotifications(user)"
                @click="openNotifications()">
                <v-icon>mdi-bell-outline</v-icon>
                Уведомления
            </v-btn>
        </v-app-bar>
        <NyBalls v-if="false"></NyBalls>
        <v-content style="margin-top: 35px">
            <v-app-bar-nav-icon v-if="false" @click.stop="primaryDrawer.model = !primaryDrawer.model"/>
            <v-progress-linear :active="$store.state.loading" :indeterminate="true" height="4"></v-progress-linear>
            <v-alert v-if="subscriptionInfo && subscriptionInfo.warn" type="warning" dense text
                     icon="mdi-calendar-alert" class="mx-3 mt-3 mb-0">
                {{ subscriptionBannerText }}
            </v-alert>
            <v-container fluid>
                <transition mode="out-in" name="fade">
                    <template v-if="!$store.state.loading">
                        <slot></slot>
                    </template>
                </transition>
                <div class="flashpool">
                    <flash-message></flash-message>
                </div>
            </v-container>
        </v-content>
        <v-navigation-drawer
            v-model="panels.notification.model"
            v-if="$helper.permission.canSeeNotifications(user)"
            right
            fixed
            width="600"
            class="notification-panel">
            <NotificationPanel
                v-on:closeNotificationPanel="panels.notification.model = false"
                @forceUpdate="notificationPanelKey++"
                :key="notificationPanelKey">
            </NotificationPanel>
        </v-navigation-drawer>
        <v-footer :inset="footer.inset" app>
            <span class="px-4">&copy; {{ new Date().getFullYear() }}</span>
        </v-footer>
        <ScrollToTop></ScrollToTop>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import UserService from "../_services/UserService";
import StompClient from "../_helpers/StompClient";
import Settings from "../app/Settings";
import Billing from "../app/Billing";
import NotificationPanel from "../notifications/NotificationPanel";
import NyBalls from "../_chunks/NyBalls";
import LawyerPlan from "@/app/LawyerPlan";
import ScrollToTop from "@/_components/ScrollToTop.vue";
import Birthday from "@/users/widgets/Birthday.vue";
import SubscriptionService from "@/_services/SubscriptionService";
import FeaturesService from "@/_services/FeaturesService";

export default {
    name: "DefaultLayout",
    components: {Birthday, ScrollToTop, LawyerPlan, NyBalls, NotificationPanel, Settings, Billing},
    data() {
        return {
            primaryDrawer: {
                model: null,
                clipped: false,
                floating: false,
                mini: false,
            },
            panels: {
                notification: {
                    model: false
                }
            },
            footer: {
                inset: false,
            },
            notificationPanelKey: 0,
            // ADMIN-only: "paid until" banner + whether this installation manages others
            subscriptionInfo: null,
            // Backend feature switches (GET /features); until loaded, gated entries stay hidden
            features: {},
        }
    },
    computed: {
        ...mapState(['user']),
        menus() {
            return [
                {
                    title: 'База заявок',
                    icon: 'mdi-format-list-bulleted-square',
                    link: '/',
                    secured: ['ADMIN', 'LAWYER_MANAGER', 'OPERATOR_MANAGER', 'OPERATOR', 'PROVIDER', 'COUNTERPART']
                },
                {
                    title: 'Лист записей',
                    icon: 'mdi-format-list-checks',
                    link: '/',
                    secured: ['RECEPTION', 'RECEPTION_COUNTERPARTY']
                },
                {
                    title: 'Лист записей',
                    icon: 'mdi-format-list-checks',
                    link: '/appointments',
                    secured: ['ADMIN', 'OPERATOR_MANAGER', 'OPERATOR']
                },
                {
                    title: 'База клиентов',
                    icon: 'mdi-account-cash-outline',
                    link: '/',
                    disabled: this.user.role !== 'LAWYER'
                },
                {
                    title: 'База клиентов',
                    icon: 'mdi-account-cash-outline',
                    link: '/clients',
                    secured: ['ADMIN', 'LAWYER_MANAGER', 'MANAGER_OKK', 'RECEPTION'],
                    disabled: !this.$helper.env.isTrue('VUE_APP_CLIENTS_ENABLED')
                },
                {
                    title: 'База договоров',
                    icon: 'mdi-text-box-multiple-outline',
                    link: '/contracts',
                    secured: ['ADMIN', 'LAWYER_MANAGER', 'LAWYER', 'RECEPTION', 'MANAGER_OKK', 'MANAGER_OGPIA', 'MANAGER_EPO', 'LAWYER_OGPIA', 'LAWYER_EPO', 'BUHGALTER'],
                    disabled: !this.$helper.env.isTrue('VUE_APP_CONTRACTS_ENABLED')
                },
                {
                    title: 'База ОКК',
                    icon: 'mdi-text-box-check-outline',
                    link: '/okk/contracts',
                    secured: ['ADMIN', 'LAWYER_MANAGER', 'LAWYER', 'RECEPTION', 'MANAGER_OKK', 'MANAGER_OGPIA', 'MANAGER_EPO', 'LAWYER_OGPIA', 'LAWYER_EPO', 'BUHGALTER'],
                    disabled: !this.$helper.env.isTrue('VUE_APP_CONTRACTS_ENABLED')
                },
                {
                    title: 'Оплаты',
                    icon: 'mdi-cash-100',
                    link: '/contract-payments',
                    secured: ['ADMIN', 'LAWYER_MANAGER', 'LAWYER', 'RECEPTION', 'BUHGALTER'],
                    disabled: !this.$helper.env.isTrue('VUE_APP_CONTRACTS_ENABLED')
                },
                {
                    title: 'База актов и выплат',
                    icon: 'mdi-text-box-check-outline',
                    link: '/acts',
                    secured: ['ADMIN', 'LAWYER_MANAGER', 'LAWYER', 'RECEPTION', 'MANAGER_OKK', 'MANAGER_OGPIA', 'MANAGER_EPO', 'LAWYER_OGPIA', 'LAWYER_EPO', 'BUHGALTER'],
                    disabled: !this.$helper.env.isTrue('VUE_APP_CONTRACTS_ENABLED')
                },
                {
                    title: 'События',
                    icon: 'mdi-clock-edit-outline',
                    link: '/contract-events',
                    secured: ['ADMIN', 'LAWYER_MANAGER', 'LAWYER', 'RECEPTION', 'MANAGER_OKK', 'MANAGER_OGPIA', 'MANAGER_EPO', 'LAWYER_OGPIA', 'LAWYER_EPO', 'BUHGALTER'],
                    disabled: !this.$helper.env.isTrue('VUE_APP_CONTRACTS_ENABLED')
                },

                {title: 'Напоминания', icon: 'mdi-calendar-check-outline', link: '/reminders'},
                {
                    title: 'Статистика ОРК',
                    icon: 'mdi-chart-bar',
                    link: '/reports',
                    secured: ['ADMIN', 'OPERATOR_MANAGER', 'OPERATOR', 'PROVIDER']
                },
                {
                    title: 'Статистика (юр. отдел)',
                    icon: 'mdi-chart-bar',
                    link: '/reports-lawyers',
                    secured: ['ADMIN', 'LAWYER_MANAGER', 'LAWYER', 'MANAGER_OKK', 'RECEPTION']
                },
                {
                    title: 'Статистика (ЭПО)',
                    icon: 'mdi-chart-bar',
                    link: '/reports-epo',
                    secured: ['ADMIN', 'MANAGER_EPO', 'LAWYER_EPO', 'LAWYER_MANAGER', 'MANAGER_OKK']
                },
                {
                    title: 'AI',
                    icon: 'mdi-robot-outline',
                    secured: ['ADMIN', 'OPERATOR_MANAGER', 'OPERATOR'],
                    disabled: !this.features.ai,
                    children: [
                        {
                            title: 'Реактивация лидов',
                            icon: 'mdi-account-reactivate-outline',
                            link: '/ai-reactivation',
                            secured: ['ADMIN', 'OPERATOR_MANAGER', 'OPERATOR']
                        },
                        {
                            title: 'AI: расходы',
                            icon: 'mdi-chart-donut',
                            link: '/ai-budget',
                            secured: ['ADMIN', 'OPERATOR_MANAGER']
                        }
                    ]
                },
                {
                    title: 'Сотрудники',
                    icon: 'mdi-account-circle',
                    link: '/users',
                    secured: ['ADMIN', 'OPERATOR_MANAGER']
                },
                {title: 'Подразделения', icon: 'mdi-account-group', link: '/subdivisions', secured: ['ADMIN']},
                // "Управляемые системы" (/managed-systems) - direct link only, see specs/saas-subscription.md
                {
                    title: 'Биллинг',
                    icon: 'mdi-cash-100',
                    link: '/payments',
                    secured: ['ADMIN', 'PROVIDER', 'COUNTERPART'],
                    disabled: !this.features.billing
                },
                // {title: 'Отчеты', icon: 'mdi-account', link: '/requests/create'},
                // {title: 'Лист записи', icon: 'mdi-account-group-outline', link: '/requests/1'},
            ]
        },
        userMenu() {
            let user = this.user;
            const isVisible = item => (!item.secured || item.secured.includes(user.role)) && !item.disabled;
            return this.menus
                .filter(isVisible)
                .map(item => item.children ? {...item, children: item.children.filter(isVisible)} : item)
                .filter(item => !item.children || item.children.length > 0);
        },
        subscriptionBannerText() {
            // daysLeft counts today, so 1 = today is the last paid day, 0 = the paid period is over
            const info = this.subscriptionInfo;
            const date = this.formatDate(info.paidUntil);
            if (info.daysLeft === 0) {
                return `Оплаченный период закончился ${date}. Работа CRM может быть приостановлена в любой момент — пополните баланс.`;
            }
            if (info.daysLeft === 1) {
                return `Сегодня последний оплаченный день (${date}). С завтрашнего дня работа CRM будет приостановлена — продлите оплату.`;
            }
            return `Оплата системы заканчивается ${date} (осталось дней: ${info.daysLeft}). После этой даты работа CRM будет приостановлена — продлите оплату заранее.`;
        },
        subscriptionDaysClass() {
            // Green while comfortable, yellow within warn-days (backend's `warn`), red on the last day
            const info = this.subscriptionInfo;
            if (info.blocked || info.daysLeft <= 1) {
                return 'error--text';
            }
            return info.warn ? 'warning--text' : 'success--text';
        },
        appLogoUrl() {
            return require(`../_assets/${process.env.VUE_APP_LOGO}`);
        },
    },
    watch: {
        // The user is fetched asynchronously in App.vue - load features/admin info once the role is known.
        'user.role': {
            immediate: true,
            handler(role) {
                if (role) {
                    FeaturesService.get().then(data => this.features = data).catch(() => {});
                }
                if (role === 'ADMIN' && !this.subscriptionInfo) {
                    this.loadSubscriptionInfo();
                    // The balance changes at midnight / on a top-up - keep the sidebar widget fresh.
                    this.subscriptionTimer = setInterval(this.loadSubscriptionInfo, 5 * 60 * 1000);
                }
            }
        }
    },
    methods: {
        formatDate(date) {
            return date ? date.split('-').reverse().join('.') : '';
        },
        formatMoney(value) {
            return Number(value).toLocaleString('ru-RU', {maximumFractionDigits: 2});
        },
        pluralDays(n) {
            const mod10 = n % 10, mod100 = n % 100;
            if (mod10 === 1 && mod100 !== 11) return 'день';
            if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'дня';
            return 'дней';
        },
        loadSubscriptionInfo() {
            SubscriptionService.getAdminInfo().then(data => this.subscriptionInfo = data).catch(() => {});
        },
        logout() {
            UserService.logout();
        },
        openNotifications() {
            this.notificationPanelKey++;
            this.panels.notification.model = true
        }
    },
    beforeCreate() {
        this.$vuetify.theme.dark = true
    },
    mounted() {
        if (this.$messaging) {
            Notification.requestPermission()
                .then(permission => {
                    if (permission === "granted") {
                        this.$messaging
                            .getToken({vapidKey: "BBicq5D95lURBugi9EtB-S0K_H1t18m3-YSAiOROovRd1qbJVrNvWehOn-KElMbHwfSbzug9cMMWfBUUdyB3-80"})
                            .then(token => {
                                UserService.updateFirebaseToken(token);
                            });
                    } else {
                        console.log("Unable to get permission to notify.");
                    }
                });
        }
    },
    created() {
        this.stompClient = new StompClient(this.user, this.$store);
        this.stompClient.init();
    },
    beforeDestroy() {
        clearInterval(this.subscriptionTimer);
        if (this.stompClient) {
            this.stompClient.disconnect();
        }
    }
}
</script>
<style scoped>
::v-deep .v-list-group__items .v-list-item {
    padding-left: 32px !important;
}
</style>


